<template>
  <div class="space-y-2">
    <div class="flex min-w-0 items-center gap-2">
      <button
        type="button"
        class="relative h-10 w-10 shrink-0 overflow-hidden rounded-lg border border-zinc-300 shadow-sm transition hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
        :style="checkerStyle"
        :aria-label="pickerOpen ? 'Close color picker' : 'Open color picker'"
        @click="pickerOpen = !pickerOpen"
      >
        <span class="absolute inset-0" :style="{ backgroundColor: displayColor }" />
      </button>

      <input
        :value="modelValue"
        type="text"
        class="min-w-0 flex-1 rounded-lg border border-zinc-300 bg-white px-3 py-2 text-sm font-mono uppercase text-zinc-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/15"
        :placeholder="placeholder"
        @input="emit('update:modelValue', $event.target.value)"
      >

      <button
        type="button"
        class="rounded-lg border border-zinc-300 bg-white px-3 py-2 text-xs font-semibold text-zinc-700 transition hover:border-blue-400 hover:bg-blue-50 hover:text-blue-700"
        @click="pickerOpen = !pickerOpen"
      >
        {{ pickerOpen ? 'Close' : 'Pick' }}
      </button>
    </div>

    <div v-if="pickerOpen">
      <ModernColorPicker
        :model-value="modelValue"
        :allow-transparent="allowTransparent"
        :enable-opacity="enableOpacity"
        @update:model-value="emit('update:modelValue', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import ModernColorPicker from '@/Components/ModernColorPicker.vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: '#FFFFFF',
  },
  allowTransparent: {
    type: Boolean,
    default: false,
  },
  enableOpacity: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '#FFFFFF',
  },
})

const emit = defineEmits(['update:modelValue'])
const pickerOpen = ref(false)

const displayColor = computed(() => {
  const value = String(props.modelValue || '').trim()
  return value || 'transparent'
})

const checkerStyle = {
  backgroundColor: '#ffffff',
  backgroundImage: 'linear-gradient(45deg, #e4e4e7 25%, transparent 25%), linear-gradient(-45deg, #e4e4e7 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e4e4e7 75%), linear-gradient(-45deg, transparent 75%, #e4e4e7 75%)',
  backgroundSize: '8px 8px',
  backgroundPosition: '0 0, 0 4px, 4px -4px, -4px 0px',
}
</script>
